import _ from 'lodash';
import React from 'react';
import { addDays } from 'date-fns';
import { connect } from 'react-redux';
import { Actions } from '../../store/actions/organisationActions';

const UsersListRow = ({ userDetails, toggleModal, reinviteUserBtn, adminUser, canEdit, canManage }) => {
  const userStatus = _.capitalize(_.lowerCase(userDetails?.status.replace('_', ' ')));

  return (
    <tr id='users-list-row' style={{ display: userDetails?.enabled ? 'table-row' : 'none' }}>
      <td>
        {
          <div>
            {userDetails?.name} {userDetails?.surname}
            {userDetails?.permissions?.organisation?.manage && (
              <span className='badge btn-success' style={{ marginLeft: '5px', cursor: 'pointer' }}>
                Organisation Manager
              </span>
            )}
          </div>
        }
      </td>
      <td>{userDetails?.email}</td>
      {adminUser && <td style={{ verticalAlign: 'center' }}>{userStatus}</td>}

      <td className='text-center'>
        {canEdit && canManage && (
          <>
            <button
              className='btn p-0'
              style={{ backgroundColor: 'transparent' }}
              id='edit-user-permissions-button'
              title='Edit User Permissions'
              onClick={() => toggleModal(true, userDetails, 'manageUser')}>
              <i className='fas fa-user-pen fa-lg'></i>
            </button>
            <button
              className='btn p-0'
              style={{ backgroundColor: 'transparent' }}
              id='disable-user-button'
              title='Disable User'
              onClick={() => toggleModal(true, userDetails, 'disableUser')}>
              <i className='fa fa-trash-o fa-lg' />
            </button>
            {reinviteUserBtn && (
              <button
                className='btn p-0'
                style={{ backgroundColor: 'transparent' }}
                id='reinvite-user-button'
                title='Reinvite User'
                onClick={() => toggleModal(true, userDetails, 'reinviteUser')}>
                <i className='fas fa-paper-plane fa-lg' />
              </button>
            )}
          </>
        )}
      </td>
    </tr>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { userDetails, adminUser } = ownProps;
  const { details } = state?.profile;
  const { userSub } = details;
  const today = new Date().toISOString();
  const expiryDate = (userDetails?.createdDate && addDays(new Date(userDetails?.createdDate), 7)?.toISOString()) || null;
  const isExpired = today > expiryDate;

  // Show reinvite button just for admin users and if user is expired and status is FORCE_CHANGE_PASSWORD.
  const reinviteUserBtn = adminUser && userDetails?.status === 'FORCE_CHANGE_PASSWORD' && isExpired;
  return {
    reinviteUserBtn,
    canEdit: userSub !== userDetails?.sub,
    canManage: !!state?.organisation?.permissions?.organisation?.manage,
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleModal: (status, item, action) => dispatch(Actions.toggleModal(status, item, action)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UsersListRow);
